export const JobForm_Page_Data = {
    "bdm-project-retail-sales-mumbai": {
        // Page Meta Fields
        META_PG_OG_Title: "BDM - Project & Retail Sales (Mumbai) | Marvel Blinds",
        META_PG_OG_Description: "BDM - Project & Retail Sales opening at Marvel Lifestyle, Mumbai.",
        META_PG_Canonical_OG_URL: `${process.env.REACT_APP_WEBSITE_URL}/job/bdm-project-retail-sales-mumbai/`,

        Job_TITLE: "BDM - Project & Retail Sales",
        Job_DESCRIPTION: "Department: Project & Retail Sales",
        Job_LOCATION: "Mumbai",
    },
    "bde-sales-marketing-mumbai": {
        // Page Meta Fields
        META_PG_OG_Title: "BDE - Sales & Marketing (Mumbai) | Marvel Blinds",
        META_PG_OG_Description: "BDE - Sales & Marketing opening at Marvel Lifestyle, Mumbai.",
        META_PG_Canonical_OG_URL: `${process.env.REACT_APP_WEBSITE_URL}/job/bde-sales-marketing-mumbai/`,

        Job_TITLE: "BDE - Sales & Marketing",
        Job_DESCRIPTION: "Department: Sales & Marketing",
        Job_LOCATION: "Mumbai",
    },
    "bdm-retail-sales-dealer-distributor-ahmedabad": {
        // Page Meta Fields
        META_PG_OG_Title: "BDM - Retail Sales (Dealer + Distributor) (Ahmedabad) | Marvel Blinds",
        META_PG_OG_Description: "BDM - Retail Sales (Dealer + Distributor) opening at Marvel Lifestyle, Ahmedabad.",
        META_PG_Canonical_OG_URL: `${process.env.REACT_APP_WEBSITE_URL}/job/bdm-retail-sales-dealer-distributor-ahmedabad/`,

        Job_TITLE: "BDM - Retail Sales (Dealer + Distributor)",
        Job_DESCRIPTION: "Department: Retail Sales (Dealer + Distributor)",
        Job_LOCATION: "Ahmedabad",
    },
    "bdm-project-sales-ahmedabad": {
        // Page Meta Fields
        META_PG_OG_Title: "BDM - Project Sales (Ahmedabad) | Marvel Blinds",
        META_PG_OG_Description: "BDM - Project Sales opening at Marvel Lifestyle, Ahmedabad.",
        META_PG_Canonical_OG_URL: `${process.env.REACT_APP_WEBSITE_URL}/job/bdm-project-sales-ahmedabad/`,

        Job_TITLE: "BDM - Project Sales",
        Job_DESCRIPTION: "Department: Project Sales",
        Job_LOCATION: "Ahmedabad",
    },
    "bdm-retail-sales-dealer-distributor-delhi": {
        // Page Meta Fields
        META_PG_OG_Title: "BDM - Retail Sales (Dealer + Distributor) (Delhi) | Marvel Blinds",
        META_PG_OG_Description: "BDM - Retail Sales (Dealer + Distributor) opening at Marvel Lifestyle, Delhi.",
        META_PG_Canonical_OG_URL: `${process.env.REACT_APP_WEBSITE_URL}/job/bdm-retail-sales-dealer-distributor-delhi/`,

        Job_TITLE: "BDM - Retail Sales (Dealer + Distributor)",
        Job_DESCRIPTION: "Department: Retail Sales (Dealer + Distributor)",
        Job_LOCATION: "Delhi",
    },
    "bdm-project-sales-delhi": {
        // Page Meta Fields
        META_PG_OG_Title: "BDM - Project Sales (Delhi) | Marvel Blinds",
        META_PG_OG_Description: "BDM - Project Sales opening at Marvel Lifestyle, Delhi.",
        META_PG_Canonical_OG_URL: `${process.env.REACT_APP_WEBSITE_URL}/job/bdm-project-sales-delhi/`,

        Job_TITLE: "BDM - Project Sales",
        Job_DESCRIPTION: "Department: Project Sales",
        Job_LOCATION: "Delhi",
    },
    "bdm-project-retail-sales-kolkata": {
        // Page Meta Fields
        META_PG_OG_Title: "BDM - Project & Retail Sales (Kolkata) | Marvel Blinds",
        META_PG_OG_Description: "BDM - Project & Retail Sales opening at Marvel Lifestyle, Kolkata.",
        META_PG_Canonical_OG_URL: `${process.env.REACT_APP_WEBSITE_URL}/job/bdm-project-retail-sales-kolkata/`,

        Job_TITLE: "BDM - Project & Retail Sales",
        Job_DESCRIPTION: "Department: Project & Retail Sales",
        Job_LOCATION: "Kolkata",
    },
    "bdm-project-retail-sales-pune": {
        // Page Meta Fields
        META_PG_OG_Title: "BDM - Project & Retail Sales (Pune) | Marvel Blinds",
        META_PG_OG_Description: "BDM - Project & Retail Sales opening at Marvel Lifestyle, Pune.",
        META_PG_Canonical_OG_URL: `${process.env.REACT_APP_WEBSITE_URL}/job/bdm-project-retail-sales-pune/`,

        Job_TITLE: "BDM - Project & Retail Sales",
        Job_DESCRIPTION: "Department: Project & Retail Sales",
        Job_LOCATION: "Pune",
    },
    "bdm-rest-of-the-world-mumbai": {
        // Page Meta Fields
        META_PG_OG_Title: "BDM - Rest of the World (Mumbai) | Marvel Blinds",
        META_PG_OG_Description: "BDM - Rest of the World opening at Marvel Lifestyle, Mumbai.",
        META_PG_Canonical_OG_URL: `${process.env.REACT_APP_WEBSITE_URL}/job/bdm-rest-of-the-world-mumbai/`,

        Job_TITLE: "BDM - Rest of the World",
        Job_DESCRIPTION: "Department: Rest of the World",
        Job_LOCATION: "Mumbai",
    },
    "project-execution-manager-operations-design-mumbai": {
        // Page Meta Fields
        META_PG_OG_Title: "Project Execution Manager - Operations + Design (Mumbai) | Marvel Blinds",
        META_PG_OG_Description: "Project Execution Manager - Operations + Design opening at Marvel Lifestyle, Mumbai.",
        META_PG_Canonical_OG_URL: `${process.env.REACT_APP_WEBSITE_URL}/job/project-execution-manager-operations-design-mumbai/`,

        Job_TITLE: "Project Execution Manager - Operations + Design",
        Job_DESCRIPTION: "Department: Operations + Design",
        Job_LOCATION: "Mumbai",
    },
    "project-coordinator-operations-design-mumbai": {
        // Page Meta Fields
        META_PG_OG_Title: "Project Coordinator - Operations + Design (Mumbai) | Marvel Blinds",
        META_PG_OG_Description: "Project Coordinator - Operations + Design opening at Marvel Lifestyle, Mumbai.",
        META_PG_Canonical_OG_URL: `${process.env.REACT_APP_WEBSITE_URL}/job/project-coordinator-operations-design-mumbai/`,

        Job_TITLE: "Project Coordinator - Operations + Design",
        Job_DESCRIPTION: "Department: Operations + Design",
        Job_LOCATION: "Mumbai",
    },
    "operation-manager-service-head-pan-india-operations-mumbai": {
        // Page Meta Fields
        META_PG_OG_Title: "Operation Manager (Service head) - Pan India - Operations (Mumbai) | Marvel Blinds",
        META_PG_OG_Description: "Operation Manager (Service head) - Pan India - Operations opening at Marvel Lifestyle, Mumbai.",
        META_PG_Canonical_OG_URL: `${process.env.REACT_APP_WEBSITE_URL}/job/operation-manager-service-head-pan-india-operations-mumbai/`,

        Job_TITLE: "Operation Manager (Service head) - Pan India - Operations",
        Job_DESCRIPTION: "Department: Operations",
        Job_LOCATION: "Mumbai",
    },
    "purchase-manager-purchase-jamnagar": {
        // Page Meta Fields
        META_PG_OG_Title: "Purchase Manager - Purchase (Jamnagar) | Marvel Blinds",
        META_PG_OG_Description: "Purchase Manager - Purchase opening at Marvel Lifestyle, Jamnagar.",
        META_PG_Canonical_OG_URL: `${process.env.REACT_APP_WEBSITE_URL}/job/purchase-manager-purchase-jamnagar/`,

        Job_TITLE: "Purchase Manager - Purchase",
        Job_DESCRIPTION: "Department: Purchase",
        Job_LOCATION: "Jamnagar",
    },
    "operation-manager-operations-jamnagar": {
        // Page Meta Fields
        META_PG_OG_Title: "Operation Manager - Operations (Jamnagar) | Marvel Blinds",
        META_PG_OG_Description: "Operation Manager - Operations opening at Marvel Lifestyle, Jamnagar.",
        META_PG_Canonical_OG_URL: `${process.env.REACT_APP_WEBSITE_URL}/job/operation-manager-operations-jamnagar/`,

        Job_TITLE: "Operation Manager - Operations",
        Job_DESCRIPTION: "Department: Operations",
        Job_LOCATION: "Jamnagar",
    },
    "finance-head-finance-and-accounting-jamnagar": {
        // Page Meta Fields
        META_PG_OG_Title: "Finance Head - Finance and Accounting (Jamnagar) | Marvel Blinds",
        META_PG_OG_Description: "Finance Head - Finance and Accounting opening at Marvel Lifestyle, Jamnagar.",
        META_PG_Canonical_OG_URL: `${process.env.REACT_APP_WEBSITE_URL}/job/finance-head-finance-and-accounting-jamnagar/`,

        Job_TITLE: "Finance Head - Finance and Accounting",
        Job_DESCRIPTION: "Department: Finance and Accounting",
        Job_LOCATION: "Jamnagar",
    },
    "interior-designer-designer-jamnagar": {
        // Page Meta Fields
        META_PG_OG_Title: "Interior Designer - Designer (Jamnagar) | Marvel Blinds",
        META_PG_OG_Description: "Interior Designer - Designer opening at Marvel Lifestyle, Jamnagar.",
        META_PG_Canonical_OG_URL: `${process.env.REACT_APP_WEBSITE_URL}/job/interior-designer-designer-jamnagar/`,

        Job_TITLE: "Interior Designer - Designer",
        Job_DESCRIPTION: "Department: Designer",
        Job_LOCATION: "Jamnagar",
    },
    "executive-assistant-mumbai": {
        // Page Meta Fields
        META_PG_OG_Title: "Executive Assistant (Mumbai) | Marvel Blinds",
        META_PG_OG_Description: "Executive Assistant opening at Marvel Lifestyle, Mumbai.",
        META_PG_Canonical_OG_URL: `${process.env.REACT_APP_WEBSITE_URL}/job/executive-assistant-mumbai/`,

        Job_TITLE: "Executive Assistant",
        Job_DESCRIPTION: "Executive Assistant opening at Marvel Lifestyle, Mumbai.",
        Job_LOCATION: "Mumbai",
    },
}
